// extracted by mini-css-extract-plugin
export default {"navLinks":"NavBar_navLinks__depCy","active":"NavBar_active__U86mV"};